import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import SiteRow from './SiteRow';
import SiteTableHead from './SiteTableHead';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import stylesDefault from '../../constants/stylesDefault';
import { changeSiteTabAction } from '../../store/ui/actions';

const styles = () => ({
  fabProgress: {
    color: 'primary',
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  paperTab: {
    display: 'inline-block'
  },
});

export class SiteTable extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    renters: PropTypes.array.isRequired,
    sites: PropTypes.array.isRequired,
    site_tab: PropTypes.any.isRequired,
    changeSiteTabAction: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      order: 'asc',
      orderBy: 'number',
      data: props.sites.sort((a, b) => (a.number < b.number ? -1 : 1)),
      page: 0,
      rowsPerPage: 500,
      role: ROLE_USER,
      selectedTab: null,
      previousSelectedTab: null,
      siteBase64: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (state.selectedTab === null) {
      newState = {...newState, selectedTab: props.site_tab};
    }
    if (props.authUser && props.roles) {
      newState = {...newState, role:props.roles[props.authUser.uid]};
    }

    if (props.sites || state.selectedTab) {
      if (props.sites && props.renters) {
        props.sites.forEach((site) => {
          site.renterName = props.renters.find(renter => renter.id === site.renter_info_id).name;
        });
      }
      if (
        state.selectedTab === null
        || state.selectedTab !== state.previousSelectedTab
        || JSON.stringify(props.sites).toString('base64') !== state.siteBase64
      ) {
        let selectedData = [];
        const actualTab = state.selectedTab ? state.selectedTab : props.site_tab;
        switch (actualTab) {
          case 0:
            selectedData = props.sites;
            break;
          case 1:
            selectedData = props.sites.filter(site => site.type === 0);
            break;
          case 2:
            selectedData = props.sites.filter(site => site.type === 1);
            break;
          case 3:
            selectedData = props.sites.filter(site => site.type === 2);
            break;
          case 4:
            selectedData = props.sites.filter(site => site.type === 4);
            break;
          case 5:
            selectedData = props.sites.filter(site => site.type === 5);
            break;
        }
        newState = {
          ...newState,
          page: 0,
          previousSelectedTab: actualTab,
          data: selectedData.sort((a, b) => SiteTable.sort(a, b, state.orderBy, state.order)),
          siteBase64: JSON.stringify(props.sites).toString('base64')
        };
      }
    }
    return newState;
  }

  static sort(a, b, property, order) {
    let prop1, prop2;
    if (property === "name") {
      prop1 = (a[property] !== null && a[property] !== undefined) ? a[property].toUpperCase() : '';
      prop2 = (b[property] !== null && b[property] !== undefined) ? b[property].toUpperCase() : '';
    } else {
      prop1 = (a[property] !== null && a[property] !== undefined) ? a[property] : -1;
      prop2 = (b[property] !== null && b[property] !== undefined) ? b[property] : -1;
    }
    if (order === 'asc') {
      return prop1 > prop2 ? -1 : 1;
    }
    return prop1 < prop2 ? -1 : 1;
  }

  handleChangeTab = (event, value) => {
    this.props.changeSiteTabAction(value);
    this.setState({ selectedTab: value });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    const data =
      (order === 'desc')
        ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
        : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
    this.setState({ data, order, orderBy });
  };

  render() {
    const { classes } = this.props;

    const {
      data, rowsPerPage, page, order, orderBy, role,
    } = this.state;

    if (Array.isArray(data)) {
      return (
        <div>
          <div className={classes.tableWrapper}>
            {role === ROLE_ADMIN &&
            <Paper className={classes.paperTab}>
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleChangeTab}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="TOUS"/>
                <Tab label="FREE FLOATING"/>
                <Tab label="STATION"/>
                <Tab label="MIXTE"/>
                <Tab label="NOLOCK"/>
                <Tab label="LLD"/>
              </Tabs>
            </Paper>
            }
            <Table style={stylesDefault.table}>
              <SiteTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
                role={role}
              />
              <TableBody>
                {data.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage).map(site => (
                  <SiteRow
                    key={site.id}
                    site={site}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
          <KobooTablePagination
            numberOfItems={data.length}
            rowsPerPage={rowsPerPage}
            label="Sites par page"
            page={page}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      );
    }
    return (
      <Typography variant="subtitle1">Aucun site</Typography>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    site_tab: state.ui.site_tab,
  };
}

export default compose(
  connect(mapStateToProps, {changeSiteTabAction}),
  withStyles(styles),
)(SiteTable);



// WEBPACK FOOTER //
// ./src/components/Site/SiteTable.jsx